import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-blue-900 text-white" data-id="element-32" data-mp="alx7gpdqwct8">
      <div className="container mx-auto px-4 lg:px-8 py-12" data-id="element-33" data-mp="akm42qo7p72n">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-34" data-mp="5nm0cmeu4gep">
          {/* Company Info */}
          <div data-id="element-35" data-mp="p17j81wwz0a">
            <h3 className="text-xl font-bold mb-4" data-id="element-36" data-mp="ordn9dqy7pb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iJtC9QLhXWZPi7KGSWTJDn/Swastik_Infra_%284%29.png" alt="Swastik Infra Developers Logo" className="h-12 w-auto mb-4" data-id="element-37" data-mp="3s2x7zn9xph8a" />
            </h3>
            <p className="text-blue-100 mb-4" data-id="element-38" data-mp="3izw1hlh5po43">
              Building excellence through innovation, quality, and customer
              satisfaction. Established in 2024.
            </p>
            <div className="flex space-x-4" data-id="element-39" data-mp="394kx9x3djzal">
              <a href="https://www.instagram.com/swastik.infra.developers" target="_blank" rel="noopener noreferrer" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" data-id="element-40" data-mp="2kdczum24onni">
                <InstagramIcon className="h-5 w-5" data-id="element-41" data-mp="2balkwca1n9r4" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-42" data-mp="340kiiw2b0f7e">
            <h3 className="text-lg font-bold mb-4" data-id="element-43" data-mp="3425cokkphw4q">Quick Links</h3>
            <ul className="space-y-2" data-id="element-44" data-mp="382fgproxucgy">
              <li data-id="element-45" data-mp="381e59m40fnyp">
                <a href="#home" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-46" data-mp="381w7r0h9myf2">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-47" data-mp="2z0y2kev3ckuw" />
                  Home
                </a>
              </li>
              <li data-id="element-48" data-mp="1im6a61xy3dll">
                <a href="#about" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-49" data-mp="1ipu5n6myaa2y">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-50" data-mp="13jfz4xyqqvw6" />
                  About Us
                </a>
              </li>
              <li data-id="element-51" data-mp="zjxn6rowdv5h">
                <a href="#projects" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-52" data-mp="zlibhzkmchuw">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-53" data-mp="pt2qsuhxtf6b" />
                  Projects
                </a>
              </li>
              <li data-id="element-54" data-mp="krvkz0zcuq2a">
                <a href="#careers" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-55" data-mp="fveu3z0rtxli">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-56" data-mp="bvnz1j47ovb6" />
                  Careers
                </a>
              </li>
              <li data-id="element-57" data-mp="267b2fu166436">
                <a href="#contact" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-58" data-mp="267ukdaqtksh7">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-59" data-mp="28s0p3kn9cmyt" />
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-60" data-mp="2dor2g07oh4gj">
            <h3 className="text-lg font-bold mb-4" data-id="element-61" data-mp="2ii2cea7se1co">Contact Information</h3>
            <ul className="space-y-3" data-id="element-62" data-mp="2ijwxboj25tgr">
              <li className="flex" data-id="element-63" data-mp="2nhf1l1m4rkif">
                <MapPinIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-64" data-mp="2ngdoyspgupyl" />
                <span className="text-blue-100" data-id="element-65" data-mp="1pugad6e7j4rx">
                  House No. 1006, Bolinj, Sopara Road, Next to Bharat Gas, Opp.
                  Karmale Talav, Bolinj, Virar(W) 401203
                </span>
              </li>
              <li className="flex" data-id="element-66" data-mp="1zq18uuk2hmwx">
                <PhoneIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-67" data-mp="23so4l6juzrze" />
                <span className="text-blue-100" data-id="element-68" data-mp="23ql5lx0qaoij">
                  +91 9823446128
                  <br data-id="element-69" data-mp="3b8kep90oryp1" />
                  +91 8208381247
                </span>
              </li>
              <li className="flex" data-id="element-70" data-mp="3fa5xtc3td97o">
                <MailIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-71" data-mp="3dqnwj7r9qg65" />
                <span className="text-blue-100" data-id="element-72" data-mp="38rued211e0zn">swastikinfra900@gmail.com</span>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-73" data-mp="3nqog8ut1uyav">
            <h3 className="text-lg font-bold mb-4" data-id="element-74" data-mp="3nqelktx282yu">Newsletter</h3>
            <p className="text-blue-100 mb-4" data-id="element-75" data-mp="3ioz1p56mc2i1">
              Subscribe to our newsletter for latest updates on projects and
              offers.
            </p>
            <form className="flex flex-col space-y-2" data-id="element-76" data-mp="3rqowmkzpljkk">
              <input type="email" placeholder="Your email address" className="px-4 py-2 bg-blue-800 border border-blue-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-blue-300" data-id="element-77" data-mp="3rq5lpo8h7vg1" />
              <button type="submit" className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded font-medium transition-colors" data-id="element-78" data-mp="jbx0504dg4xd">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="bg-blue-950 py-4" data-id="element-79" data-mp="12x6yoy252vqm">
        <div className="container mx-auto px-4 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-80" data-mp="12vvwh2ocdw1m">
          <p className="text-blue-200 text-sm" data-id="element-81" data-mp="oz07u1vlxw0g">
            &copy; {new Date().getFullYear()} Swastik Infra Developers. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-2 md:mt-0" data-id="element-82" data-mp="f6b0nj73b4ax">
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-83" data-mp="jxj9oe4icnnk">
              Privacy Policy
            </a>
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-84" data-mp="64l8uc9aq3cm">
              Terms of Use
            </a>
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-85" data-mp="3seeew08s2k4t">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;